import { Button, Grid, Typography, Stack } from '@arquivei/atenas';
import Image from 'next/image';

import supportBg from '../../assets/helppage.png';

const WHATSAPP_NUMBER = '5516981475095';

const WHATSAPP_TEXT = 'Olá, gostaria de tirar dúvidas técnicas sobre a Qive.';

const Support = () => {
  const handleClick = () => {
    const message = WHATSAPP_TEXT;

    const encodedMessage = encodeURIComponent(message);

    const urlRedirect = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    if (window) {
      window.open(urlRedirect, '_blank');
    }

    return;
  };

  return (
    <Stack
      direction="row"
      component="section"
      data-testid="support-section"
      minHeight="70vh"
    >
      <Image
        src={supportBg}
        alt="Imagem de várias pessoas com fone de ouvido usando computador"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
        quality={100}
        loading="eager"
        priority
      />

      <Stack position="relative" justifyContent="center">
        <Grid container>
          <Grid md={7} xs={12}>
            <Typography level="display1" textColor="common.white" mb={3}>
              Conheça nossos canais de ajuda & suporte
            </Typography>
            <Typography textColor="common.white" maxWidth="540px">
              Precisou de ajuda? Conte com nossos materiais de apoio, canais de
              atendimento e nosso time técnico para te auxiliar em toda sua
              experiência e integração de nossa API.
            </Typography>
            <Button
              component="a"
              href="#contact-specialist"
              size="lg"
              sx={{
                mt: 4,
                backgroundColor: '#FF4719',
                '&:hover:not(.Joy-focused)': {
                  backgroundColor: '#D13200',
                },
              }}
              onClick={handleClick}
            >
              Fale com um consultor
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};

export default Support;
